import React from "react";
import {
  ComposableMap,
  Geographies,
  Geography,
  Marker,
} from "react-simple-maps";
import { FaMapMarkerAlt } from "react-icons/fa";
import "../App.css"; // You can define .map-container here

const locations = [
  { name: "Canada", coordinates: [-106.3468, 56.1304], users: 25 },
  { name: "USA", coordinates: [-100, 40], users: 42 },
  { name: "Brazil", coordinates: [-51.9253, -14.2350], users: 15 },
  { name: "UK", coordinates: [-3.4359, 55.3781], users: 33 },
  { name: "Russia", coordinates: [105.3188, 61.5240], users: 18 },
  { name: "Egypt", coordinates: [30.8025, 26.8206] },     // Egypt
  { name: "India", coordinates: [78.9629, 20.5937], users: 61 },
  { name: "China", coordinates: [104.1954, 35.8617], users: 52 },
  { name: "Australia", coordinates: [133.7751, -25.2744], users: 21 },
  { name: "Nigeria", coordinates: [8.6753, 9.0820], users: 29 },
];

const WorldMap = () => {
  return (
    <div className="map-container">
      <ComposableMap projectionConfig={{ scale: 150 }} style={{ width: "100%", height: "auto" }}>
        <Geographies geography="/features.json">
          {({ geographies }) =>
            geographies.map((geo) => (
              <Geography
                key={geo.rsmKey}
                geography={geo}
                style={{
                  default: { fill: "#eae3f0", stroke: "#fff", strokeWidth: 0.5 },
                  hover: { fill: "#d0b7e4" },
                  pressed: { fill: "#c9a8e0" },
                }}
              />
            ))
          }
        </Geographies>

        {locations.map(({ name, coordinates, users }, i) => (
          <Marker key={i} coordinates={coordinates}>
            <g transform="translate(-10, -30)">
              <FaMapMarkerAlt size={20} color="#7e52b1" />
             
            </g>
          </Marker>
        ))}
      </ComposableMap>
    </div>
  );
};

export default WorldMap;
